import { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../../context/UserContext";
import { SettingOption } from "../../../components/SettingOption/setting-option";
import { NotificationsContext } from "../../../context/NotificationsContext";
import { PATCH, UpdateSetting } from "../../../utils/httpUtils";

const defaultProps = {
  enable_notifications: true,
  enable_sms_notifications: true,
  enable_storage_capacity_notifications: true,
  enable_payment_notifications: true,
};

export default function NotificationSettings(props = defaultProps) {
  useEffect(() => {}, []);

  const { user, loginUser } = useContext(UserContext);
  const { pushNotification } = useContext(NotificationsContext);

  const valid = useRef(new Map());

  const [enableNotifications, setEnableNotifications] = useState(props.enable_notifications);
  const [enableSMSNotifications, setEnableSMSNotifications] = useState(props.enable_sms_notifications);
  const [enableStorageCapacityNotifications, setEnableStorageCapacityNotifications] = useState(props.enable_storage_capacity_notifications);
  const [enablePaymentNotifications, setEnablePaymentNotfications] = useState(props.enable_payment_notifications);

  function EnableNotifications(enabled) {
    setEnableNotifications(enabled);
    UpdateSetting("enable_notifications", enabled, user).then((response) => {
      if (response.success) {
        let message = enabled ? "Notifications are now enabled" : "Notifications disabled";
        pushNotification("Setting Updated", message);
      } else {
        setEnableNotifications(!enabled);
        pushNotification("Setting Failed To Update", (response.error && response.error.message) ?? "Unknown error occured");
      }
    });
  }

  function EnableSMSNotifications(enabled) {
    setEnableSMSNotifications(enabled);
    UpdateSetting("enable_sms_notifications", enabled, user).then((response) => {
      if (response.success) {
        let message = enabled ? "SMS Notifications are now enabled" : "SMS notifications disabled";
        pushNotification("Setting Updated", message);
      } else {
        setEnableNotifications(!enabled);
        pushNotification("Setting Failed To Update", (response.error && response.error.message) ?? "Unknown error occured");
      }
    });
  }

  function EnableStorageCapacityNotifications(enabled) {
    setEnableStorageCapacityNotifications(enabled);
    UpdateSetting("enable_storage_capacity_notifications", enabled, user).then((response) => {
      if (response.success) {
        let message = enabled ? "Storage Capacity Notifications are now enabled" : "SMS notifications disabled";
        pushNotification("Setting Updated", message);
      } else {
        setEnableStorageCapacityNotifications(!enabled);
        pushNotification("Setting Failed To Update", (response.error && response.error.message) ?? "Unknown error occured");
      }
    });
  }

  function EnablePaymentNotifications(enabled) {
    setEnablePaymentNotfications(enabled);
    UpdateSetting("enable_payment_notifications", enabled, user).then((response) => {
      if (response.success) {
        let message = enabled ? "Payment Notifications are now enabled" : "SMS notifications disabled";
        pushNotification("Setting Updated", message);
      } else {
        setEnablePaymentNotfications(!enabled);
        pushNotification("Setting Failed To Update", (response.error && response.error.message) ?? "Unknown error occured");
      }
    });
  }

  return (
    <div>
      <SettingOption
        id={"notification-option-1"}
        controlType={"toggle"}
        defaultValue={enableNotifications}
        onChange={(value) => EnableNotifications(value)}
        description="Enable Notifications"
      />

      <SettingOption
        id={"notification-option-5"}
        controlType={"toggle"}
        defaultValue={enableSMSNotifications}
        onChange={(value) => EnableSMSNotifications(value)}
        description="Enable SMS Notifications"
      />

      <SettingOption
        id={"notification-option-2"}
        controlType={"toggle"}
        defaultValue={enableStorageCapacityNotifications}
        onChange={(value) => EnableStorageCapacityNotifications(value)}
        description="Enable Storage Capacity Notifications"
      />

      <SettingOption
        id={"notification-option-3"}
        controlType={"toggle"}
        defaultValue={enablePaymentNotifications}
        onChange={(value) => EnablePaymentNotifications(value)}
        description="Enable Payment Notifications"
      />
    </div>
  );
}
